import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteContractPriceList } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractPriceListDelete = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteContractPriceList,
        onSuccess: (_, { contractId }) =>
            queryClient.invalidateQueries({ queryKey: queries.contracts.detail(contractId).queryKey }),
    });
};
